// This season's Treatment Subgrid layer (a yearly copy of the master subgrid layer
// with Status reset to "Not Treated"). Empty = backend default (master layer).

const KEY = "pioneer_subgrid_layer_id";

export function getSubgridLayerId(): string {
  return localStorage.getItem(KEY) || "";
}

export function setSubgridLayerId(id: string): void {
  if (id) localStorage.setItem(KEY, id);
  else localStorage.removeItem(KEY);
}
